import { DuotoneIcon, DuotoneIconProps } from './DuotoneIcon';

export function OrganizationIcon(props: Omit<DuotoneIconProps, 'name'> & { name?: DuotoneIconProps['name'] }) {
  return <DuotoneIcon name="building-memo" {...props} />;
}
